import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    activeIndex: "/category"
  },
  mutations: {
    setIndex(state, index) {
      state.activeIndex = index;
    }
  },
  actions: {},
  modules: {}
});



// WEBPACK FOOTER //
// ./src/store/index.js